const EVENTS = {
  ORGANIZATION_CHANGED: "organization.changed",
};
const channel = new BroadcastChannel("dubrink");

export function broadcastOrganizationChange() {
  channel.postMessage({
    type: EVENTS.ORGANIZATION_CHANGED,
  });
}

export function listenForOrganizationChanges() {
  channel.addEventListener("message", (event) => {
    if (event.data?.type === EVENTS.ORGANIZATION_CHANGED) {
      window.location.reload();
    }
  });
}
